import {
  Button, ButtonGroup, Icon, IconButton, Modal, ModalBody, ModalCloseButton, ModalContent, ModalFooter, ModalHeader, ModalOverlay,
  Table,
  Tbody,
  Td,
  Text,
  Tr,
} from '@chakra-ui/react';
import { get, identity } from '@submize/lodash';
import { BsChevronLeft, BsChevronRight } from 'react-icons/bs';
import { formatDate } from '../../helpers/date';
import { ipToSring } from '../../helpers';

const SubmitionViewModal = ({
  isOpen, onClose, item, cols = [], prev, next,
}) => {
  if (!item) return null;
  return (
    <Modal isOpen={isOpen} onClose={onClose} size="xl">
      <ModalOverlay />
      <ModalContent>
        <ModalHeader pb="0">Response</ModalHeader>
        <ModalCloseButton size="sm" />
        <ModalBody>
          <Text color="gray.400" fontSize="sm">
            This message was sent
            {' '}
            {ipToSring(item.ip, item.country)}
            {' '}
            at
            {' '}
            {formatDate(item.date)}
          </Text>
          <Table size="sm" variant="striped" my="4" color="gray.700">
            <Tbody>
              {cols.map((col, c) => (
                <Tr key={c}>
                  <Td width="120px" verticalAlign="top"><Text as="b" pl="2">{col.label}</Text></Td>
                  <Td>{get(item, `data.${col.path}`, '')}</Td>
                </Tr>
              ))}
            </Tbody>
          </Table>
        </ModalBody>

        <ModalFooter justifyContent="space-between">
          <ButtonGroup size="sm" isAttached variant="outline">
            <IconButton aria-label="prev submission" icon={<Icon as={BsChevronLeft} />} isDisabled={!prev} onClick={prev || identity} />
            <IconButton aria-label="next submission" icon={<Icon as={BsChevronRight} />} isDisabled={!next} onClick={next || identity} />
          </ButtonGroup>
          <Button size="sm" colorScheme="blue" mr={3} onClick={onClose}>
            Close
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};
export default SubmitionViewModal;
